//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getEleves, getSelectedCreneaux, getFormulesEleves } from "../../store/selectors.js";
import { elevesSlice } from "../../store/elevesSlice.js";
import { selectedCreneauxSlice } from "../../store/selectedCreneauxSlice.js";


//Import React Hooks
import { useEffect, useState } from 'react'

//import MUI
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import DeleteIcon from '@mui/icons-material/Delete';
import FormControl from '@mui/material/FormControl';

//config
import { listFidelite, listNiveau } from "../../config/niveau-fidelite-config.js";

//Translate utils :
import { translator } from "../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

function ElevePopover({ eleve, setAnchorEl }) {

    /* useEffect(() => { // at first render
    }, [eleve]) */

    const dispatch = useDispatch();
    const lang = useSelector(getLang) //global state : language

    let allEleves = useSelector(getEleves);
    let currentEleve = allEleves.find((e) => e.id === eleve.id);
    let listAge = [];
    for (let i = 1; i <= 99; i++) { listAge.push(i); }

    function handleClose() { // close popover
        setAnchorEl(null);
    }



    function handleChangeEleve(value, attribut) {

        let eleveModif = {
            age: attribut === "age" ? value : currentEleve.age,
            prenom: attribut === "prenom" ? value : currentEleve.prenom,
            niveau: attribut === "niveau" ? value : currentEleve.niveau,
            fidelite: attribut === "fidelite" ? value : currentEleve.fidelite,
            checked: attribut === "check" ? value : currentEleve.checked,
            id: currentEleve.id
        }
        dispatch(elevesSlice.actions.modifyEleve(eleveModif));

    }

    return (

        <div className="eleve-popover">
            <div className="eleve-popover-line">
                <p className="eleve-popover-line-prenom">{eleve.prenom}</p>

                <FormControl>
                    <InputLabel id="label-age">Age</InputLabel>
                    <Select

                        className="eleve-popover-line-age"
                        labelId="label-age"
                        label="Age"
                        value={currentEleve.age}
                        size="small"
                        variant="outlined"
                        onChange={(e) => handleChangeEleve(e.target.value, "age")}
                    >{
                            listAge.map((age) => (
                                <MenuItem key={age} value={age}>{age}</MenuItem>
                            ))
                        }

                    </Select>
                </FormControl>

                <FormControl>
                    <InputLabel id="label-niveau">{translator("Niveau surf", lang, "elevesInput1")}</InputLabel>
                    <Select
                        className="eleve-popover-line-niveau"
                        labelId="label-niveau"
                        label={translator("Niveau surf", lang, "elevesInput1")}
                        value={currentEleve.niveau}
                        size="small"
                        variant="outlined"
                        onChange={(e) => handleChangeEleve(e.target.value, "niveau")}
                    >{
                            listNiveau.map((niveau) => (
                                <MenuItem key={niveau.id} value={niveau.id}>{niveau.intitule}</MenuItem>
                            ))
                        }

                    </Select>
                </FormControl>

                <FormControl>
                    <InputLabel id="label-fidelite">{translator("Fidélité", lang, "elevesInput2")}</InputLabel>
                    <Select
                        className="eleve-popover-line-fidelite"
                        labelId="label-fidelite"
                        label={translator("Fidélité", lang, "elevesInput2")}
                        value={currentEleve.fidelite}
                        size="small"
                        variant="outlined"
                        onChange={(e) => handleChangeEleve(e.target.value, "fidelite")}
                    >{
                            listFidelite.map((fidelite) => (
                                <MenuItem key={fidelite.id} value={fidelite.id}>{fidelite.intitule}</MenuItem>
                            ))
                        }

                    </Select>
                </FormControl>


                <Button
                    variant="contained"
                    size="small"
                    className="eleve-popover-boutons-cancel"
                    onClick={_ => handleClose()}
                >{translator("Fermer", lang, "popoverFermer")}</Button>

            </div>
        </div>
    );
}

export default ElevePopover;